import React from 'react'
import { Redirect, Route } from 'react-router-dom'
//import Authentication from "../../Containers/AuthenticationContainer.js";

const PrivateRoute = ({ component: Component, isLoged: IsLogged, ...rest }) => {

  return (

    <Route
      {...rest}
      render={props =>
        IsLogged===true ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        )
      }
    />
  )
}

export default PrivateRoute;

//function mapStateToProps(state, ownProps) {  
//  return {isLoggedIn: state.user.logedIn}
//}
//
//export default withRouter(connect(mapStateToProps, null)(PrivateRoute));